//@flow
import * as _ from 'lodash';
import { urlsConstants } from '../constants/url.constant';
import { defaultService } from './defaultService';

export const importarPedidoService = {
  doGet,
  doSave,
  findByFiltro,
  doDelete,
};

function findByFiltro(options: Options, filter: any): Promise<any> {
  const params = [];
  if (_.get(filter, 'pontoAtendimentoId')) {
    params.push(
      `pontoAtendimentoId=${encodeURIComponent(filter.pontoAtendimentoId)}`
    );
  }
  if (_.get(filter, 'cliente')) {
    params.push(
      `codigoCliente=${encodeURIComponent(filter.cliente.codigoCliente)}`
    );
  }
  if (_.get(filter, 'status')) {
    params.push(`status=${encodeURIComponent(filter.status)}`);
  }

  if (_.get(filter, 'numeroPedido')) {
    params.push(`numeroPedido=${encodeURIComponent(filter.numeroPedido)}`);
  }

  if (filter.urgente != null) {
    params.push(`urgente=${encodeURIComponent(filter.urgente)}`);
  }

  if (filter.createdAt != null) {
    let iso;

    if (filter.createdAt instanceof Date) {
      iso = filter.createdAt.toISOString();
    } else if (typeof filter.createdAt === 'string') {
      iso = new Date(filter.createdAt).toISOString();
    }

    params.push(`createdAt=${encodeURIComponent(iso)}`);
  }

  if (_.get(filter, 'tipoPedido') !== undefined && filter.tipoPedido !== null) {
    params.push(`tipoPedido=${encodeURIComponent(filter.tipoPedido)}`);
  }

  if (_.get(filter, 'criadoPor') !== undefined && filter.criadoPor !== null) {
    params.push(`criadoPor=${encodeURIComponent(filter.criadoPor)}`);
  }

  if (
    _.get(filter, 'aprovadoPor') !== undefined &&
    filter.aprovadoPor !== null
  ) {
    params.push(`aprovadoPor=${encodeURIComponent(filter.aprovadoPor)}`);
  }

  if (_.get(options, 'page') !== undefined) {
    params.push(`page=${options.page - 1}`);
  }
  const queryString = params.length ? `?${params.join('&')}` : '';
  return defaultService.doGet(
    `${urlsConstants.API_PEDIDO_IMPORTADO}filtro${queryString}`,
    options
  );
}

function doDelete(id) {
  return defaultService.doDelete(`${urlsConstants.API_PEDIDO_IMPORTADO}${id}`);
}

function doGet(id) {
  return defaultService.doGet(`${urlsConstants.API_PEDIDO_IMPORTADO}${id}`);
}

function doSave(pa) {
  return defaultService.doSave(urlsConstants.API_PEDIDO_IMPORTADO, pa);
}
